import { usersApi } from 'entities/users';
import { toast } from 'react-toastify';

type ChangeUserDataApiReqType = {
  id: number;
  body: {
    reason: string;
    status: number;
  };
};

const changeStatusDataApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    changesStatusData: builder.mutation<any, ChangeUserDataApiReqType>({
      query: ({ id, body }) => ({
        url: `/account/admin/users/${id}/status`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error, arg) => {
        const error_message = error?.status;
        if (error) {
          toast.error(error_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        } else {
          toast.success('Данные сохранены', {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        return [
          { type: 'User', id: arg.id },
          { type: 'Users', id: 'ALL' },
        ];
      },
    }),
  }),
});

export const { useChangesStatusDataMutation } = changeStatusDataApi;
